import requester from '@/lib/axios';
import { TextQuestion, TextQuestionDTO } from '@/models/Question';

const baseUrl = 'text-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

export const getTextQuestion = async (id: number) => {
  const { data: textActivity } = await requester().get<TextQuestion>(
    `${baseUrl}/${id}/`,
  );

  return textActivity;
};

export const createTextQuestionIntoActivity = async (
  activityId: number,
  body: TextQuestionDTO,
) => {
  const { data } = await requester().post<TextQuestion>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateTextQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: TextQuestionDTO,
) => {
  const { data } = await requester().patch<TextQuestion>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};

export const deleteTextQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
